import { Box, Icon, Link, StackProps, VStack } from "@chakra-ui/react"
import NextLink from "next/link"
import { IconType } from "react-icons"

type ProductFeaturesItemProps = StackProps & {
  title: string
  value: string
  icon: IconType
  url?: string
}

const ProductFeaturesItem = ({
  title,
  value,
  icon,
  url,
  ...rest
}: ProductFeaturesItemProps) => {
  return (
    <>
      {url ? (
        <Link
          as={NextLink}
          variant={"link"}
          href={`${url}`}
          title={title}
          _hover={{
            textDecoration: "none",
          }}
          role={"group"}
        >
          <VStack
            spacing={5}
            width={"25%"}
            textAlign={"center"}
            minW={24}
            {...rest}
          >
            <Box fontSize={"xs"}>{title}</Box>
            <Icon
              as={icon}
              w={12}
              h={12}
            />
            <Box
              fontSize={"xs"}
              color={"blue.600"}
              textDecoration={"underline"}
              textDecorationStyle={"dashed"}
              textUnderlineOffset={"0.3em"}
              _groupHover={{
                textDecoration: "none",
              }}
            >
              {value}
            </Box>
          </VStack>
        </Link>
      ) : (
        <VStack
          spacing={5}
          width={"25%"}
          textAlign={"center"}
          minW={24}
          {...rest}
        >
          <Box fontSize={"xs"}>{title}</Box>
          <Icon
            as={icon}
            w={12}
            h={12}
          />
          <Box
            fontSize={"xs"}
            fontWeight={"500"}
          >
            {value}
          </Box>
        </VStack>
      )}
    </>
  )
}

export default ProductFeaturesItem
